import { createContext } from 'react';
import { Theme } from '../constants/enums';

/**
 * Интерфейс контекста темы
 */
export interface ThemeContextType {
  /** Текущая выбранная тема пользователем (из Theme enum) */
  theme: Theme;
  
  /** Функция для изменения темы */
  setTheme: (theme: Theme) => void;
  
  /** Переключение между light и dark темами */
  toggleTheme: () => void;
}

/**
 * Контекст для управления темами приложения
 */
export const ThemeContext = createContext<ThemeContextType | undefined>(undefined);
